import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=fb0eb0ce&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0eb0ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb0eb0ce')) {
      api.createRecord('fb0eb0ce', component.options)
    } else {
      api.reload('fb0eb0ce', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=fb0eb0ce&scoped=true&", function () {
      api.rerender('fb0eb0ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yB17zVejxfka/JS/comp/Accordion.vue"
export default component.exports